import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-yoga-room',
  templateUrl: './yoga-room.component.html',
  styleUrls: ['./yoga-room.component.scss']
})
export class YogaRoomComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
